<div class="side-menu-container">
  <div class="main-menu">
    <ng-container *ngFor="let menuSection of mainMenuSections">
      <pop-side-menu-section [menuSection]="menuSection"></pop-side-menu-section>
    </ng-container>
  </div>

  <div class="secondary-menu">
    <ng-container *ngFor="let menuSection of secondaryMenuSections">
      <pop-side-menu-section [menuSection]="menuSection"></pop-side-menu-section>
    </ng-container>
  </div>

</div>
